import Cookies from "js-cookie";

import { useShouldRenderCatfishAd } from "../_hooks/useShouldRenderCatfishAd";
import { GoogleAdTypeEnum } from "./config";
import GoogleAd from "./GoogleAd";

export default function CatfishAd() {
  const shouldRenderCatfishAd = useShouldRenderCatfishAd();
  console.log(shouldRenderCatfishAd, "shouldRenderCatfishAd");
  if (!shouldRenderCatfishAd) return null;

  return (
    <GoogleAd
      type={GoogleAdTypeEnum.CATFISH}
      onSlotRenderEnded={(e) => {
        if (e.isEmpty) {
          console.log("Catfish ad: ad is empty, not displaying.");
          return;
        }
        Cookies.set("catfishDisplayed", "yes", { expires: 4 / 24 }); // 4 hours in days
      }}
    />
  );
}
